export function pcRoot() {
  // return "http://172.10.0.39:9202/zxsc/";
  return "https://zxscg.com/zxsc/";
}
